import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import CustomSelectSimple from "../../evidencije/CustomSelectSimple";

const riziciAll = ["DA", "NE", "SVE"];
const spremaAll = ["0", "OSS", "SSS", "VSS"];
const iskustvoAll = ["0", "0.5-1g", "1-2g", "3-5g", "5-10g", "10+g"];

const filterDataInitial = {
  rizik: "",
  sprema: "",
  iskustvo: ""
};

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

function Filter({ filterData, setFilterData }) {
  const { dictionary } = useGlobalContext();

  const handleChange = (newValue, field) => {
    setFilterData((prev) => ({ ...prev, [field]: newValue }));
  };

  const handlePonisti = () => {
    setFilterData(filterDataInitial);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        gap: "10px",
        marginTop: "15px"
      }}
    >
      <CustomSelectSimple
        label={dictionary["rizik"]}
        allValues={riziciAll}
        selectedValue={filterData.rizik}
        onSelectChange={(newValue) => handleChange(newValue, "rizik")}
        style={{ width: "120px" }}
      />
      <CustomSelectSimple
        label={dictionary["sprema"]}
        allValues={spremaAll}
        selectedValue={filterData.sprema}
        onSelectChange={(newValue) => handleChange(newValue, "sprema")}
        style={{ width: "120px" }}
      />
      <CustomSelectSimple
        label={dictionary["iskustvo"]}
        allValues={iskustvoAll}
        selectedValue={filterData.iskustvo}
        onSelectChange={(newValue) => handleChange(newValue, "iskustvo")}
        style={{ width: "120px" }}
      />
      <div onClick={handlePonisti} style={{ width: "20%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["ponisti"]}
        </Button>
      </div>
    </div>
  );
}

export default Filter;
